import { InlineWidget } from 'react-calendly';
import MetaTags from '../../components/MetaTags';
import { defaultImageUrl, primaryImageUrl } from '../services/Quote';
import Header from '../../components/layout/Header';
import { Box } from '@mui/material';
import { calStyles } from '../../assets/styles/home';
import Footer from '../../components/layout/Footer';

const Calendly = () => {
  return (
    <div>
      <MetaTags
        title="A&E Financial Services - Appointment. Read | taxes | processes"
        description="Discover A&E Financial Services, your trusted source for personalized insurance, read taxes, and financial solutions, including expert tax services and efficient processes, catering to your various insurance needs 24/7."
        keywords="Income tax in Houston,Income tax preparation in Houston,Tax office near Stafford,Tax office near 77036,Tax office near 77082,Tax office near 77099,Tax office near 77007,Tax office near 77479,Tax office near 77401,Tax office near 77489, Taxes, Financial, Financial Services, read, processes"
        url="https://www.aefinancialservicesllc.com"
        imageUrl={primaryImageUrl || defaultImageUrl}
      />
      <Header headerType="relative" />
      <Box sx={calStyles.appointment}></Box>
      <div className="App">
        <InlineWidget url="https://calendly.com/aefinancialservicesllc-info" />
      </div>
      <Footer />
    </div>
  );
};
export default Calendly;
